module.exports = __webpack_public_path__ + "img/welcome-start-scratch.4567f1e6.svg";